import { useMemo } from 'react';
import { useSelector } from '../../../react-redux';

// 单独设置一个特殊值 控制这种不在权限列表 但是有需要展示的界面
// key == 'special_perm' 时 为特殊值
function usePerm(key) {
  const state = useSelector(state => state.get('func'));

  const { permMap, permReady } = useMemo(() => {
    return {
      permMap: state.get('permMap'),
      permReady: state.get('permReady')
    };
  }, [state]);

  if (key === 'special_perm') {
    return true;
  }

  if (!key || !permReady) {
    return false;
  }

  if (Array.isArray(key)) {
    return key.every(item => {
      return permReady ? !!permMap[item] : false;
    });
  }
  return permReady ? !!permMap[key] : false;
}

export default usePerm;
